import React from 'react'

const LocationPinSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 9.423 12.564'
    >
      <path
        id='location-pin-svgrepo-com'
        d='M12.712,0A4.712,4.712,0,0,0,8,4.712a4.638,4.638,0,0,0,.894,2.735c.01.018.012.039.023.057l3.141,4.712a.785.785,0,0,0,1.307,0L16.506,7.5c.012-.018.013-.038.023-.057a4.638,4.638,0,0,0,.894-2.735A4.712,4.712,0,0,0,12.712,0Zm0,6.282a1.571,1.571,0,1,1,1.571-1.571A1.571,1.571,0,0,1,12.712,6.282Z'
        transform='translate(-8)'
        fill='#0090ff'
      />
    </svg>
  )
}

export default LocationPinSvg
